import { ModuleContainingUserMaterial } from '../api';

export function sortModulesByCatalogName(modules: ModuleContainingUserMaterial[]): ModuleContainingUserMaterial[] {
  return modules.sort((a, b) => a.catalogName.localeCompare(b.catalogName));
}

export function sortSubModulesByNiceName(
  subModules: ModuleContainingUserMaterial['books'],
): ModuleContainingUserMaterial['books'] {
  return subModules.sort((a, b) => a.niceName.localeCompare(b.niceName));
}
